module.exports = __webpack_public_path__ + "static/media/more_active.11e2d864.png";